module.exports = __webpack_public_path__ + "img/lz.7f0c2abb.gif";